var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmniToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 14.998a5.999 5.999 0 1 0-5.39-3.363l1.506-1.506a4.043 4.043 0 1 1 2.77 2.76l-1.508 1.508A5.975 5.975 0 0 0 9 14.998Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.37 13.157a1.08 1.08 0 1 1-1.527-1.527 1.08 1.08 0 0 1 1.527 1.527ZM10.56 9a1.56 1.56 0 1 1-3.12 0 1.56 1.56 0 0 1 3.12 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniToken);
export default __webpack_public_path__ + "static/media/omni-token.3dbf801da6e4bdd1f680e66724886c8f.svg";
export { ForwardRef as ReactComponent };